import { createRoutine } from "redux-saga-routines";
import { handleActions } from "redux-actions";

export const contactFormRoutine = createRoutine("app/contactForm/SEND");

export default handleActions({}, {});
